import React from 'react';
import { FormattedMessage } from 'react-intl';
import StoreColumn from '../../../components/columns/store-column';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';

export const Store = {
  getName: () => <FormattedMessage defaultMessage='Store' description='customerOrdersGrid.columns.store' id='HEmloy' />,
  id: 'store',

  render: (data) => {
    if (data.orderNumberCount > 1) {
      return <Multiple />;
    }
    if (!data || !data.store) {
      return '';
    }
    const { storeGuid } = data.store;
    if (!storeGuid) {
      return '';
    }
    return <StoreColumn storeGuid={storeGuid} />;
  },
};
